/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object, string } from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { useSelector } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import PassportLanderHero from './PassportLanderHero';
import PassportLanderOffers from './PassportLanderOffers';
import PassportLanderReviews from './PassportLanderReviews';
import PassportLanderBrands from './PassportLanderBrands';
import PassportFAQ from '../PassportFAQ';
import { getFeatureFlags } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import isPassportEnrollmentActive from '../../../../helpers/passportEnrollmentVisibility';
import LoyaltySchema from '../../../../helpers/Seo/LoyaltySchema';

const useStyles = makeStyles(() => ({
    page: { background: '#fff', color: '#222' },
    offers: { padding: '24px 32px 32px', borderBottom: '2px solid #d2d2d2', '@media (max-width: 600px)': { padding: '28px 20px 36px' } },
    offersHeading: { textAlign: 'center', fontFamily: 'Fields, Georgia, serif', fontSize: 28, margin: '0 0 50px', '@media (max-width: 600px)': { fontSize: 24, marginBottom: 28 } },
    faq: { maxWidth: 1010, margin: '32px auto 24px', padding: '0 20px', '& > div': { width: '100%', margin: '0 auto' } },
    terms: { maxWidth: 1010, margin: '0 auto', padding: '24px 20px 64px', fontSize: 13, lineHeight: 1.6, '& a': { color: 'inherit' } },
}));

const PassportEnrollmentLander = ({ data, page, cartIconLabel }) => {
    const classes = useStyles();
    const featureFlags = useSelector(getFeatureFlags);
    const hasEnrollmentConfig = Object.prototype.hasOwnProperty.call(featureFlags, 'is-celebrations-passport-enrollment-active-ft');
    const enrollmentActive = !hasEnrollmentConfig || isPassportEnrollmentActive(featureFlags, 'enrollment_lander');
    const header = data?.header || {};
    const offers = data?.member_offers || {};
    const reviews = data?.member_reviews || {};
    const rebound = data?.rebound_presentation || {};
    const brandImage = rebound.participating_brands_group_image_desktop;
    const terms = data?.sales_and_shipping_terms;
    const styling = data?.styling || {};

    return (
        <main
            className={classes.page}
            data-component="passportEnrollmentLander"
            style={{ backgroundColor: styling.page_background_color || '#fff', color: styling.page_font_color || '#222' }}
        >
            <LoyaltySchema path={page.path} />
            {!enrollmentActive && <PassportFAQ />}
            {enrollmentActive && (
                <>
                    <PassportLanderHero data={header} skus={data?.passport_skus || {}} cartIconLabel={cartIconLabel} styling={styling} />
                    {offers.offer?.length > 0 && (
                        <section className={classes.offers}>
                            <h2 className={classes.offersHeading}>{offers.heading}</h2>
                            <PassportLanderOffers offers={offers.offer} />
                        </section>
                    )}
                    {reviews.review?.length > 0 && (
                        <PassportLanderReviews heading={reviews.heading} reviews={reviews.review} />
                    )}
                    {brandImage?.url && (
                        <PassportLanderBrands data={rebound} skus={data?.passport_skus || {}} cartIconLabel={cartIconLabel} enrolledCopy={header?.enrolled_path_copy} styling={styling} />
                    )}
                    <div className={classes.faq}><PassportFAQ /></div>
                    {terms && <div className={classes.terms}>{ReactHtmlParser(terms)}</div>}
                </>
            )}
        </main>
    );
};

PassportEnrollmentLander.propTypes = {
    data: object.isRequired,
    page: object,
    cartIconLabel: string,
};
PassportEnrollmentLander.defaultProps = { page: {}, cartIconLabel: 'Cart' };

export default PassportEnrollmentLander;
